import styled from 'styled-components'

const FullHeightWrapper = styled.div`
  min-height: ${(props: { isMobile: boolean }) =>
    props.isMobile ? 'calc(100vh - 84px)' : 'auto'};
  position: relative;
`

export default FullHeightWrapper
